import { createFileRoute } from '@tanstack/react-router';
import { Suporte } from '@/features/suporte/page/Suporte';

export const Route = createFileRoute('/a/suporte/')({
    component: Suporte,
});
